import { configValue } from "./runtimeEnv";
//test ortami icin yapilan degisiklerin burada yapilmasi gerekir.
// Every value below resolves in the same order: runtime env.js -> build-time
// REACT_APP_* -> the default in this file. See src/runtimeEnv.ts. The runtime step is
// what lets a single image serve every environment; the keys exported to the browser are
// listed in docker-entrypoint.sh.
export const SERVICEURL = configValue(
  "REACT_APP_SERVICEURL",
  process.env.REACT_APP_SERVICEURL,
  "https://wiserapitest.rdcboard.com/"
);
export const v1link = configValue(
  "REACT_APP_V1_LINK",
  process.env.REACT_APP_V1_LINK,
  "https://rdcboard.com/"
);
export const finanslink = configValue(
  "REACT_APP_FINANS_LINK",
  process.env.REACT_APP_FINANS_LINK,
  "https://finans.rdcboard.com/"
);
export const NEXT_PUBLIC_DIRECTUS_URL = configValue(
  "REACT_APP_DIRECTUS_URL",
  process.env.REACT_APP_DIRECTUS_URL,
  "https://cms.rdcpartner.com"
);
export const WEBSOCKET_URL = configValue(
  "REACT_APP_WEBSOCKET_URL",
  process.env.REACT_APP_WEBSOCKET_URL,
  "wss://test.api.ai.rdc.com.tr/v1"
);

export const keycloakLogin =
  configValue(
    "REACT_APP_KEYCLOAK_LOGIN",
    process.env.REACT_APP_KEYCLOAK_LOGIN,
    "false"
  ).toLowerCase() === "true";

export const keycloakConfig = {
  url: configValue(
    "REACT_APP_KEYCLOAK_URL",
    process.env.REACT_APP_KEYCLOAK_URL,
    "http://localhost:8082"
  ),
  realm: configValue(
    "REACT_APP_KEYCLOAK_REALM",
    process.env.REACT_APP_KEYCLOAK_REALM,
    "wiser-dev"
  ),
  clientId: configValue(
    "REACT_APP_KEYCLOAK_CLIENT_ID",
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    "test"
  ),
  redirectUri: configValue(
    "REACT_APP_KEYCLOAK_REDIRECT_URI",
    process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
    "http://localhost:3000"
  ),
  responseType: "code",
  scope: "openid profile email",
};

// Derived from keycloakConfig, so it picks up the runtime values automatically.
export const keycloakURL =
  `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth` +
  `?client_id=${keycloakConfig.clientId}` +
  `&response_type=${keycloakConfig.responseType}` +
  `&scope=${encodeURIComponent(keycloakConfig.scope)}` +
  `&redirect_uri=${encodeURIComponent(keycloakConfig.redirectUri)}`;
